<template>
	<div class="tempD">
		<div class="pageTit"><span @click="goHome">1522智能设计之家首页</span> > <span>个人中心</span></div>
		<div class="uInfoD">
			<div class="uphoto">
				<img :src="userObj?userObj.headimg?imgAPI + userObj.headimg:require('../../../public/icon/001.jpg'):require('../../../public/icon/001.jpg')" @click="setHeadImg" />
				<div v-if="userObj?!userObj.headimg:''" class="changeHeadImg" @click="setHeadImg">点我设置</div>
				<input style="display: none;" type="file" name="ediutorUpload" id="ediutorUpload_1" @change="selectImage_1" value="" />
			</div>
			<div class="uInfoTest">
				<div class="uInfoTest_one">
					<div class="unickname">
						<span>{{userObj?userObj.nickname:''}}</span><span style="">注册时间 {{userObj?userObj.reg_time:''}}</span>
					</div>
					<div class="editBtn btn_addWorks" @click="open_userEdit">编辑</div>
				</div>
				<div class="uInfoTest_two">
					<div class="selfIntroduction">
						<p v-if="userObj?userObj.introduce_myself=='':''">您什么都还没介绍</p>
						<p v-else="">{{userObj?userObj.introduce_myself:''}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="my_worksD">
			<div class="one_tit">
				<span>我的作品</span>
				<button class="btn_addWorks" @click="works_add">添加作品</button>
				<el-select v-model="statusValue" placeholder="选择状态查看" class="oU_select" v-on:change="handelStatus">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<button class="btn_addWorks" style="background-color: red;" v-if="checkIdArr.length>0" @click="dele_api('多选')">删除已选</button>
			</div>
			<div class="my_works_arrD">
				<table class="my_works_table" border="" cellspacing="" cellpadding="">
					<tr>
						<th></th>
						<th>作品标题</th>
						<th>图片数量</th>
						<th>作品描述</th>
						<th>发布时间</th>
						<th>状态</th>
						<th>操作</th>
					</tr>
					<tr class="tbody_tr" v-for="ob in worksArr">
						<td style="align-items: center;line-height: 20px;">
							<input class="checkWorks_box" v-model="checkIdArr" type="checkbox" name="" :id="ob.m_works_id" :value="ob.m_works_id" />
						</td>
						<td>{{ob.title}}</td>
						<td>{{handlePhotoNum(ob.works)}}</td>
						<td style="max-width: 350px;">
							<span>{{ob.remark}}</span>
						</td>
						<td>{{ob.create_time}}</td>
						<td>
							<span v-if="ob.status==1">待审核</span>
							<span v-if="ob.status==2" style="color: green;">已发布</span>
							<span v-if="ob.status==99" style="color: red;">审核未通过</span>
						</td>
						<td class="table_operation">
							<button class="btn_del" @click="dele_api(ob.m_works_id)">删除</button>
							<button class="btn_edit" @click="open_works_edit(ob)">编辑</button>
							<button class="btn_seeInfo" @click="open_seeInfo(ob)">查看详情</button>
						</td>
					</tr>
				</table>
				<div v-if="worksArr.length==0" style="text-align: center;line-height: 200px;">您还没有作品!</div>
				<div class="tablePage">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNumber" :page-sizes="[5, 10, 20, 50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="cTotal"></el-pagination>
				</div>
			</div>
		</div>

		<el-dialog title="" width="50%" :visible.sync="works_add_dlog" :show-close="false" class="myDlog_1">
			<works_add_dlog v-on:parentMethod="communication"></works_add_dlog>
		</el-dialog>
		<el-dialog title="" width="50%" :visible.sync="works_edit_dlog" :show-close="false" class="myDlog_1">
			<worksEditDlog :pageParams="editWorksPageParams" v-on:parentMethod="communication" v-if="works_edit_dlog"></worksEditDlog>
		</el-dialog>
		<el-dialog title="" width="100%" :visible.sync="works_info_dlog" :show-close="false" class="myDlog_1 myDlog_opa infoDlog">
			<worksInfoDlog :pageParams="editWorksPageParams" v-on:parentMethod="communication" v-if="works_info_dlog"></worksInfoDlog>
		</el-dialog>
		<el-dialog title="" width="50%" :visible.sync="userEdit_dlog" :show-close="false" class="myDlog_1">
			<userEditDlog :pageParams="editWorksPageParams" v-on:parentMethod="communication" v-if="userEdit_dlog"></userEditDlog>
		</el-dialog>
	</div>
</template>

<script>
	import baseConst from '../../assets/js/baseConst.js' //注意路
	const works_add_dlog = () =>
		import("@/components/oUserAdmin/works_add.vue"); //添加作品
	const worksEditDlog = () =>
		import("@/components/oUserAdmin/works_edit.vue"); //修改作品
	const worksInfoDlog = () =>
		import("@/components/oUserAdmin/works_info.vue"); //作品详情
	const userEditDlog = () =>
		import("@/components/oUserAdmin/user_edit.vue"); //用户资料编辑
	export default {
		components: {
			works_add_dlog,
			worksEditDlog,
			worksInfoDlog,
			userEditDlog
		},
		data() {
			return {
				works_add_dlog: false, //添加作品
				works_edit_dlog: false, //修改作品
				works_info_dlog: false, //作品详情
				userEdit_dlog: false, //用户资料编辑
				editWorksPageParams: {},
				pageNumber: 1,
				limit: 10,
				cTotal: 0,
				pageSize: 10,
				worksArr: [],
				options: [{
					value: '',
					label: '所有'
				}, {
					value: 1,
					label: '待审核'
				}, {
					value: 2,
					label: '审核通过'
				}, {
					value: 99,
					label: '审核未通过'
				}],
				statusValue: '',
				checkIdArr: [],
				userObj: {},
				imgAPI: '',
			}
		},
		created: function() {
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			//console.log(localStorage.getItem('ind_user'))
			let userObj = JSON.parse(localStorage.getItem('ind_user'));
			_this.userObj = userObj;
			if(!_this.userObj) {
				_this.$message.error("登录过期，请重新登录");
				_this.goHome();
			}else{
				_this.getWorksList();
			}
			
		},
		mounted: function() {
			let _this = this;
			_this.setTempDH();
		},
		methods: {
			/**  * -----s设置高度    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			setTempDH() {
				let offsetHeight = document.documentElement.clientHeight;
				document.getElementsByClassName("tempD")[0].style.minHeight = offsetHeight + 'px';
			},
			/**  * -----获取表格数据    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			getWorksList() {
				let _this = this;
				let params = {
					pageNumber: _this.pageNumber,
					limit: _this.pageSize,
					status: _this.statusValue
				};
				_this.getApi('/api/member/getWorksList', params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.worksArr = res.data.data;
							_this.pageNumber = res.data.pageNumber;
							_this.cTotal = res.data.total;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			handleSizeChange(val) {
				let _this = this;
				_this.pageSize = val;
				_this.getWorksList();
			},
			handleCurrentChange(val) {
				let _this = this;
				_this.pageNumber = val;
				_this.getWorksList();
			},
			handelStatus(val) {
				let _this = this;
				_this.statusValue = val;
				_this.getWorksList();
			},
			/**  * -----处理图集图片数量    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			handlePhotoNum(imgText) {
				let arr = imgText.split('|');
				return arr.length;
			},

			/**  * -----删除    以及批量删除
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			dele_api(id) {
				let _this = this;
				let checkIdArr_1 = _this.checkIdArr;
				const h = this.$createElement;
				let idsArr;
				if(id == '多选') {
					idsArr = checkIdArr_1;
				} else {
					idsArr = [id];
				}
				this.$msgbox({
					title: '不可逆操作提示',
					message: h('p', null, [
						h('span', null, '确认要删除改作品吗 '),
						h('i', {
							style: 'color: teal'
						}, '？')
					]),
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					beforeClose: (action, instance, done) => {
						if(action === 'confirm') {
							instance.confirmButtonLoading = true;
							instance.confirmButtonText = '执行中...';
							_this.postApi('/api/member/bathDelWorks', {
									ids: idsArr
								})
								.then((res) => {
									//console.log(res)
									if(res.status == '00') {
										_this.$message.success('删除成功');
										_this.getWorksList();
										setTimeout(() => {
											//done();
											setTimeout(() => {
												instance.confirmButtonLoading = false;
												done();
											}, 300);
										}, 1000);
									} else {
										_this.$message.error(res.message);
										return;
									}
								})
								.catch((err) => {})
						} else {
							done();
						}
					}
				}).then(action => {
					this.$message({
						type: 'info',
						message: 'action: ' + action
					});
				});
			},
			/**  * -----设置头像    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			setHeadImg() {
				let _this = this;
				document.getElementById("ediutorUpload_1").click();
			},
			/**  * -----选择图片    
			 * @version 1.0  * @author 您的大名 2019年12月3日  * */
			selectImage_1(files) {
				let _this = this;
				let file = files.target.files[0];
				let isPNG = file.type === 'image/png';
				let isJPG = file.type === 'image/jpeg';
				let is2M = file.size / 1024 / 1024 < 2;
				if(!isPNG && !isJPG) {
					this.$message.error('只能上传png,jpg格式的图片！');
					return;
				}
				if(!is2M) {
					this.$message.error('不能大于2M');
					return;
				}
				let formData = new FormData();
				formData.append("img", file);
				formData.append("type", 'userHead');
				let params = {};
				_this.$axios({
					url: '/api/upload/img',
					method: 'post',
					onUploadProgress: function(progressEvent) { //原生获取上传进度的事件
						if(progressEvent.lengthComputable) {
							//属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
							//如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
							//callback1(progressEvent);
						}
					},
					data: formData
				}).then(res => {
					let uploadImgUrl = res.data.data;
					_this.postApi('/api/member/setUserHead', {
							headImg: uploadImgUrl[0]
						})
						.then((res) => {
							console.log(res)
							if(res.status == '00') {
								_this.$message.success('设置成功');
								_this.userObj.headimg = uploadImgUrl;
								localStorage.setItem("ind_user", JSON.stringify(_this.userObj));
							} else {
								_this.$message.error(res.message);
								return;
							}
						})
						.catch((err) => {})

				}).then(error => {
					console.log(error)
				})
			},

			/**  * -----添加作品    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			works_add() {
				let _this = this;
				_this.works_add_dlog = true;
			},
			/**  * -----修改作品    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			open_works_edit(ob) {
				let _this = this;
				_this.editWorksPageParams = JSON.parse(JSON.stringify(ob))
				setTimeout(function() {
					_this.works_edit_dlog = true;
				}, 100)
			},
			/**  * -----查看详情    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			open_seeInfo(ob) {
				let _this = this;
				_this.editWorksPageParams = JSON.parse(JSON.stringify(ob))
				_this.works_info_dlog = true;
			},
			/**  * -----编辑资料    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			open_userEdit(ob) {
				let _this = this;
				_this.userEdit_dlog = true;
			},
			/**  * -----去往首页     * @version 1.0  * @author 您的大名 2019年12月3日  * */
			goHome() {
				let _this = this;
				_this.$router.replace({
					path: '/homePage'
				});
				//_this.$router.push('/');
			},
			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_add':
						_this.works_add_dlog = false;
						_this.getWorksList();
						break;
					case 'works_edit':
						_this.works_edit_dlog = false;
						_this.getWorksList();
						break;
					case 'works_info':
						_this.works_info_dlog = false;
						break;
					case 'user_edit':
						let userObj = JSON.parse(localStorage.getItem('ind_user'));
						_this.userObj = userObj;
						_this.userEdit_dlog = false;
						break;
					default:
				}
			},
		},
		watch: {
			'checkIdArr': {
				handler: function(val, oldVal) {
					//console.log(val)
				},
				deep: true
			}
		},
	}
</script>

<style scoped>
	.tempD {
		width: 100%;
		padding: 0 4rem;
		box-sizing: border-box;
		margin: auto;
		background-image: url(../../../public/img/001.jpg);
		background-size: cover;
		background-repeat: no-repeat;
	}
	
	.pageTit {
		height: 5rem;
		line-height: 5rem;
		border-bottom: 1px solid #ccc;
	}
	
	.pageTit span:nth-child(1) {
		font-weight: bold;
		cursor: pointer;
	}
	
	.pageTit span:nth-child(2) {
		color: #7D7D7D;
	}
	
	.uInfoD {
		display: flex;
		flex-direction: row;
		padding: 1rem;
	}
	
	.uphoto {
		position: relative;
		width: 8rem;
		height: 8rem;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.changeHeadImg {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: rgb(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		text-align: center;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
	}
	
	.uphoto img {
		width: 100%;
		cursor: pointer;
	}
	
	.uInfoTest {
		flex: 1;
		padding: 0 0.5rem;
	}
	
	.uInfoTest_one {
		height: 50%;
		width: 100%;
		border-bottom: 1px solid #ccc;
		display: inline-flex;
		align-items: center;
		position: relative;
	}
	
	.unickname {
		font-size: 1.6rem;
	}
	
	.unickname span:nth-child(2) {
		font-size: 12px;
		color: #7D7D7D;
		margin-left: 10px;
	}
	
	.editBtn {
		position: absolute;
		right: 0;
	}
	
	.uInfoTest_two {
		overflow: hidden;
		height: 50%;
	}
	
	.selfIntroduction {
		font-size: 13px;
		padding: 5px;
	}
	
	.my_worksD {
		background-color: rgba(255, 255, 255, 0.4);
		padding: 1rem 0;
		box-sizing: border-box;
		border-radius: 5px;
	}
	
	.one_tit {
		height: 3rem;
		line-height: 3rem;
		padding: 0 0.5rem;
		font-weight: bold;
	}
	
	.btn_addWorks {
		border: none;
		margin-left: 15px;
		background-color: #6C6C6C;
		color: #fff;
		padding: 5px 10px;
		cursor: pointer;
		border-radius: 3px;
	}
	
	.my_works_table {
		width: 90%;
		margin: auto;
		border: none;
		border-collapse: collapse;
		/*加上这个将tr和td的border属性分开*/
	}
	
	.my_works_table tr {
		/*line-height: 3rem;*/
		padding: 20px 0;
	}
	
	.my_works_table tr th {
		border: none;
		padding: 20px 0;
	}
	
	.my_works_table tr td {
		border: none;
		text-align: center;
		padding: 20px 0;
	}
	
	.tbody_tr {
		border-bottom: 1px solid #ccc;
		/*line-height: 5rem!important;*/
	}
	
	.tbody_tr:hover {
		transform: scale(1.001);
		box-shadow: 0 0 5px #7D7D7D;
		-webkit-box-shadow: 0 0 5px #7D7D7D;
		-moz-box-shadow: 0 0 5px #7D7D7D;
		-ms-box-shadow: 0 0 5px #7D7D7D;
		-o-transform: scale(1.001);
		-moz-transform: scale(1.001);
		-ms-transform: scale(1.001);
		-o-transform: scale(1.001);
	}
	
	.table_operation {
		text-align: right!important;
	}
	
	.table_operation button {
		border: none;
		margin-left: 0.5rem;
		cursor: pointer;
	}
	
	.table_operation .btn_del {}
	
	.tablePage {
		width: 90%;
		text-align: right;
		height: 50px;
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
		box-sizing: border-box;
		margin-left: 5%!important;
	}
	
	.checkWorks_box {
		width: 30px;
		height: 30px;
		cursor: pointer;
	}
	
	.oU_select {
		margin-left: 15px;
	}
</style>
<style type="text/css">
	.myDlog_1 .el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100% - 30px);
		max-width: calc(100% - 30px);
	}
	
	.myDlog_1 .el-dialog .el-dialog__header {
		padding: 0;
	}
	
	.myDlog_1 .el-dialog .el-dialog__body {
		flex: 1;
		overflow: auto;
		padding: 10px;
		border-radius: 10px;
	}
	
	.infoDlog.myDlog_1 .el-dialog {
		min-height: 100%;
		min-width: 100%;
	}
	
	.oU_select .el-input--suffix .el-input__inner {
		background-color: #6c6c6c;
		height: 30px;
		color: #fff;
	}
	
	.oU_select .el-input--suffix .el-input__inner::placeholder {
		color: #fff;
	}
</style>